module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MW-008acdf29e228c1a8086392aacf43964.png";